import OAuth2Metadata_vue_vue_type_script_setup_true_lang_default from "./OAuth2Metadata.vue.script.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/OAuth2Metadata.vue
var OAuth2Metadata_default = OAuth2Metadata_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { OAuth2Metadata_default as default };

//# sourceMappingURL=OAuth2Metadata.vue.js.map